import { User } from '@/types/user';
import { QueryKey } from '@/configs/queryKeys';
import { UUID } from '@/types/types';
import EntityApi from './EntityApi';
import httpClient from './httpClient';

class UserApi extends EntityApi<User> {
	constructor() {
		super(QueryKey.users);
		this.changePassword = this.changePassword.bind(this);
	}

	async changePassword(payload: {
		id: UUID;
		currentPassword: string;
		newPassword: string;
	}) {
		await httpClient.patch<void>(
			`${this.queryKey}/${payload.id}/change-password`,
			payload
		);
		return 1;
	}
}

export default new UserApi();
